import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 18l-14 -4","key":"svg-0"}],["path",{"d":"M19 14l-14 -4l14 -4","key":"svg-1"}]]

const IconMathEqualLower = createReactComponent('outline', 'math-equal-lower', 'MathEqualLower', __iconNode);

export default IconMathEqualLower;